import React, { Component, Fragment } from 'react';

import Footer from './FooterFixed';

import CheckBox from '../../artzu-ui/src/CheckBox';
import Modal from '../../artzu-ui/src/Modal';
import Button from '../../artzu-ui/src/Button';
import Icon from '../../artzu-ui/src/Icon';

import ScrollLock from 'react-scrolllock';
import EncourageScroll from '../EncourageScroll';

import { withRouter, Link } from 'react-router-dom';

import { withApollo } from 'react-apollo';
import gql from 'graphql-tag';

class ReviewProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      applicationComplete: props.currentStep === 5,
      modalOpen: false,
      checked: props.currentStep === 5,
      resetModal: false
    };
  }

  toggleModal = () => this.setState({ modalOpen: !this.state.modalOpen });

  toggleCheck = () => this.setState({ checked: !this.state.checked });

  onNextClick = () => {
    if (this.state.checked) {
      this.props.incrementStep();
      this.setState({ applicationComplete: true });

      this.updateUser();
    } else {
      this.toggleModal();
    }
  };

  onBackClick = () => this.props.decrementStep();

  openResetModal = () => this.setState({ resetModal: true });

  triggerUberReset = () => {
    const { accountName } = this.props.currentUser;

    this.props.client
      .mutate({
        mutation: RESET_UBER
      })
      .then(() => this.props.refetch())
      .then(() => {
        if (accountName) {
          this.openResetModal();
        } else {
          this.props.goToUberTerms();
        }
      });
  };

  updateUser = () => {
    this.props.client
      .mutate({
        mutation: UPDATE_USER,
        variables: {
          userFields: {
            status: 'signed_up'
          }
        }
      })
      .then(() => {
        this.props.refetch();
        this.props.loadUser('status', 'signed_up');
      });
  };

  render() {
    const {
      currentUser,
      currentStep,
      setStep,
      title,
      goToUberTerms
    } = this.props;
    const {
      checked,
      modalOpen,
      applicationComplete,
      resetModal
    } = this.state;

    return (
      <Fragment>
        <ScrollLock>
          <EncourageScroll className="apply__review">
            <div className="apply__review--container">
              <div className="apply__body--title"> {title}</div>
              <div>
                {' '}
                Please review the following information to confirm that it
                is accurate before submitting the application.{' '}
              </div>
              <div className="apply__review--info">
                <div className="apply__review--section-left">
                  <div className="apply__review--section-container">
                    <div className="apply__review--title-container">
                      <h3>Profile Photo</h3>
                      <h4
                        className="apply__review--edit"
                        onClick={() => setStep(1)}>
                        Edit
                      </h4>
                    </div>
                    <img
                      className="apply__review--image-profile"
                      src={currentUser.uberProfileImage}
                      alt="profile"
                    />
                    <div className="apply__review--title-container">
                      <h3>Profile Information</h3>
                    </div>
                    <div className="apply__review--content--container">
                      <div className="apply__review--content">
                        <h4>First Name</h4>
                        <div> {currentUser.firstName} </div>
                      </div>
                    </div>
                    <div className="apply__review--content--container">
                      <div className="apply__review--content">
                        <h4>Last Name</h4>
                        <div> {currentUser.lastName} </div>
                      </div>
                    </div>
                    <div className="apply__review--content--container">
                      <div className="apply__review--content">
                        <h4>Phone Number</h4>
                        <div> {currentUser.mobile} </div>
                      </div>
                    </div>
                    <div className="apply__review--content--container">
                      <div className="apply__review--content">
                        <h4>Email</h4>
                        <div> {currentUser.email} </div>
                      </div>
                    </div>
                    {currentUser.accountName ? (
                      <div className="apply__review--content--container">
                        <div className="apply__review--content">
                          <h4>Uber Account</h4>
                          <div> {currentUser.accountName} </div>
                        </div>
                        <h4
                          className="apply__review--edit"
                          onClick={() => this.triggerUberReset()}>
                          Edit
                        </h4>
                      </div>
                    ) : null}
                  </div>{' '}
                </div>
                <div className="apply__review--section-right">
                  <div className="apply__review--section-container">
                    <div className="apply__review--title-container">
                      <h3>Driver's License</h3>
                      <h4
                        className="apply__review--edit"
                        onClick={() => setStep(2)}>
                        Edit
                      </h4>
                    </div>
                    <div className="apply__review--content">
                      <h4>Driver's License Number</h4>
                      <div> {currentUser.driversLicenseNumber} </div>
                    </div>
                    <img
                      className="apply__review--image-license"
                      src={currentUser.driversLicenseImage}
                      alt="profile"
                    />
                  </div>
                  <div className="apply__review--section-container">
                    <div className="apply__review--title-container">
                      <h3>Work Eligibility</h3>
                      <h4
                        className="apply__review--edit"
                        onClick={() => setStep(3)}>
                        Edit
                      </h4>
                    </div>
                    <img
                      className="apply__review--image-license"
                      src={currentUser.employmentEligibilityImage}
                      alt="profile"
                    />
                  </div>
                </div>
              </div>
            </div>
          </EncourageScroll>
        </ScrollLock>
        <Modal open={resetModal}>
          <div className="apply__uber--terms-modal">
            <div className="apply__uber--terms-modal-text">
              First, visit{' '}
              <a
                href="https://help.uber.com/logout"
                rel="noopener noreferrer"
                target="_blank">
                https://help.uber.com/logout
              </a>{' '}
              to log out of your previously connected account.
            </div>
            <div className="apply__uber--terms-modal-text">
              Next, return to this page to connect to the right Uber
              Account.
            </div>
            <Button label="Okay" onClick={() => goToUberTerms()} />
          </div>
        </Modal>
        <Modal open={modalOpen}>
          <div className="apply__uber--terms-modal">
            <div className="apply__uber--terms-modal-text">
              You need to agree to the terms and conditions of Autzu before
              submitting the application.{' '}
            </div>
            <Button label="Okay" onClick={() => this.toggleModal()} />
          </div>
        </Modal>
        <Modal open={applicationComplete}>
          <div className="apply__complete--container">
            <Icon size="5x" name="BlueCheck" />
            <div>Your application has been successfully submitted.</div>
            <div>
              You can find updates to your application in the Dashboard.
            </div>

            {/applyMobile/.test(window.location.href) ? (
              <a href="/dashboard?didCompleteSignUp=true">
                <Button primary fullWidth label="Go to Dashboard" />
              </a>
            ) : (
              <Link to="/dashboard">
                <Button
                  primary
                  fullWidth
                  label="Go to Dashboard"
                  onClick={() => {}}
                />
              </Link>
            )}
          </div>
        </Modal>
        <Footer
          currentStep={currentStep}
          currentUser={currentUser}
          back
          active
          onNextClick={this.onNextClick}
          onBackClick={this.onBackClick}
          label={'Submit'}>
          <CheckBox
            checkState={checked}
            label={
              <div>
                {' '}
                I agree to the{' '}
                <a rel="noopener noreferrer" target="_blank" href="/terms">
                  {' '}
                  terms and conditions
                </a>
                .
              </div>
            }
            onClick={this.toggleCheck}
          />{' '}
        </Footer>
      </Fragment>
    );
  }
}

const UPDATE_USER = gql`
  mutation updateUser($userFields: UserAttributes!) {
    updateUser(userFields: $userFields) {
      user {
        email
      }
      errors {
        message
      }
    }
  }
`;

const RESET_UBER = gql`
  mutation resetUber {
    resetUber {
      user {
        id
      }
      errors {
        message
      }
    }
  }
`;

export default withRouter(withApollo(ReviewProfile));



// WEBPACK FOOTER //
// ./src/components/TorontoApply/ReviewProfile.js